export function zendeskIsLoaded() {
	return !!window["$zopim"];
}
